console.log('Product customizer script loaded');

// ============================================
// GLOBAL STATE MANAGEMENT
// ============================================
window.pdpState = {
  option1: '', // Style Name (e.g., "Laser Engraving")
  option2: '', // Size
  option3: '', // Color
  currentType: '', // Style Type Filter (e.g., "Customization")
  variantId: null // Current variant ID
};

// ============================================
// CORE RESOLVER FUNCTION
// ============================================

// Sync all radio buttons inside <variant-radios> to match the given variant's options
// Works for any number of options — no hardcoded indices
function syncVariantRadios(variant) {
  var container = document.querySelector('variant-radios');
  if (!container || !variant || !variant.options) return;
  var fieldsets = Array.from(container.querySelectorAll('fieldset'));
  fieldsets.forEach(function(fieldset, index) {
    var targetValue = variant.options[index];
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    radios.forEach(function(radio) {
      radio.checked = (radio.value === targetValue);
    });
  });
}

/*
 * Mirror the checked radios into pdpState.
 *
 * pdpState is only a cache, and it went stale: NOTHING updated option3 when the
 * size changed. Selecting 12oz on flip-traveler left the state reading 16oz, so
 * picking a 12oz-only colour (Basal Grey) resolved against 16oz, matched no
 * variant, and the page stayed on the previous one - the customer saw the new
 * size while every downstream value still described the old variant.
 *
 * The DOM is the authority here: a change event fires after the radio's state
 * has updated, so whatever is checked is what the customer actually chose.
 * Index 0 is the style picker's position and is left alone, because its radios
 * only catch up once a resolve has succeeded (syncVariantRadios) - mirroring it
 * here would clobber a style the customer had just chosen.
 */
function syncPdpStateFromRadios(exceptIndex) {
  var picker = document.querySelector('variant-radios');
  if (!picker) return;

  var fieldsets = picker.querySelectorAll('fieldset');
  for (var i = 1; i < fieldsets.length && i < 3; i++) {
    if (i === exceptIndex) continue;

    var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
    if (!checked) continue;

    if (i === 1) window.pdpState.option2 = checked.value;
    else window.pdpState.option3 = checked.value;
  }
}

/*
 * Map a metafield-derived style label onto the product's REAL option value.
 *
 * window.productStyleMetafields is keyed by `style_metaobject.name | downcase`,
 * so the style metafield hands us names like "uv printing". The style picker
 * needs the product's own option string - "UV Printing" - because
 * resolveVariant() compares variants with === against their literal option
 * values. Guessing the capitalisation is what broke it: the fallback in
 * nameCapitalizationMap only upper-cases the first letter, turning
 * "uv printing" into "Uv printing", which matches no variant. The result was
 * silently no-op: the picker changed, the radio never moved, and the price
 * stayed on the previous variant.
 *
 * So trust the product over the guess: find the option value the label is
 * trying to name, case-insensitively, and return it verbatim.
 */
function resolveStyleOptionValue(label) {
  var data = window.productData;
  var wanted = String(label == null ? '' : label).trim().toLowerCase();
  if (!wanted || !data) return label;

  var values = [];
  var styleIndex = -1;

  // Preferred source: the product's own option list, plus the index of the
  // option that this picker drives.
  if (data.options_with_values && data.options_with_values.length) {
    for (var i = 0; i < data.options_with_values.length; i++) {
      var optName = String(data.options_with_values[i].name || '').toLowerCase();
      if (optName.indexOf('style') !== -1 || optName.indexOf('technique') !== -1 || optName.indexOf('method') !== -1) {
        styleIndex = i;
        break;
      }
    }
    if (styleIndex !== -1) values = data.options_with_values[styleIndex].values || [];
  }

  // Fallback: read the values off the variants, which always carry them. The
  // style picker drives option 1 when the option name gave us nothing.
  if (!values.length && data.variants) {
    if (styleIndex === -1) styleIndex = 0;
    data.variants.forEach(function (variant) {
      var value = variant.options && variant.options[styleIndex];
      if (value && values.indexOf(value) === -1) values.push(value);
    });
  }

  for (var j = 0; j < values.length; j++) {
    if (String(values[j]).trim().toLowerCase() === wanted) return values[j];
  }

  // Nothing matched: hand back the label unchanged rather than inventing one.
  return label;
}

function resolveVariant() {
  console.log('Resolving variant with state:', window.pdpState);

  // Build current selected options array (option1, option2, option3, ...)
  var selectedOptions = [
    window.pdpState.option1,
    window.pdpState.option2,
    window.pdpState.option3
  ];

  // Find matching variant (dynamic — works for any number of options)
  let matchedVariant = null;
  if (window.productVariants) {
    for (const variantId in window.productVariants) {
      const variant = window.productVariants[variantId];
      if (variant.options && variant.options.every(function(opt, i) {
        return opt === selectedOptions[i];
      })) {
        matchedVariant = variant;
        break;
      }
    }
  }

  /*
   * Safety net. The exact comparison above is what we want, because the option
   * strings should now be the product's own. But a label that still arrives in
   * the wrong case would otherwise match nothing and fail silently - the picker
   * would change and the price would not. Retry case-insensitively so a casing
   * slip degrades to "works" instead of "does nothing"; syncVariantRadios then
   * rewrites the state from the variant's own values, so it self-corrects.
   */
  if (!matchedVariant && window.productVariants) {
    for (const variantId in window.productVariants) {
      const variant = window.productVariants[variantId];
      if (variant.options && variant.options.every(function(opt, i) {
        var a = String(opt == null ? '' : opt).trim().toLowerCase();
        var b = String(selectedOptions[i] == null ? '' : selectedOptions[i]).trim().toLowerCase();
        return a === b;
      })) {
        console.warn('[pdp] variant matched case-insensitively; a style label is mis-cased', selectedOptions);
        matchedVariant = variant;
        break;
      }
    }
  }
  
  if (matchedVariant) {
    console.log('Matched variant:', matchedVariant);
    
    // Update state with variant ID
    window.pdpState.variantId = matchedVariant.id;
    
    // Update state with variant ID
    window.pdpState.variantId = matchedVariant.id;
    
    // Update hidden variant ID input
    const variantInput = document.querySelector('[id^="product-select-"]');
    if (variantInput) {
      variantInput.value = matchedVariant.id;
    }

    // Sync variant-radios radio buttons to match (generic — any number of options)
    syncVariantRadios(matchedVariant);
    
    // Update price
    updateVariantPricing(matchedVariant);
    
    // Attach metafield images to the variant
    const variantMetafield = window.variantMetafields?.[matchedVariant.id];
    if (variantMetafield) {
      matchedVariant.metafield_images = variantMetafield.images;
    }

    // Update gallery
    if (typeof window.updateProductGallery === 'function') {
      window.updateProductGallery(matchedVariant);
    }
    
    // Update button state
    updateActionButton(matchedVariant);
    
    // Update URL
    if (window.history && window.history.replaceState) {
      const newUrl = window.location.pathname + '?variant=' + matchedVariant.id;
      window.history.replaceState({}, '', newUrl);
    }

    /*
     * Announce the change.
     *
     * The style picker drives the radios by assigning radio.checked, and that
     * does NOT fire a change event - so assigning the hidden input and the
     * radios left the rest of the page unaware that the variant had moved. The
     * bulk pricing calculator is the one that matters: its base price is
     * per-variant and drives the whole percentage tier ladder, so without this
     * it kept quoting the previous variant's prices.
     *
     * Dispatched last, once the hidden input, the radios and the URL all agree.
     */
    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { variant: matchedVariant, variantId: matchedVariant.id },
      bubbles: true
    }));
  } else {
    console.warn('No matching variant found for state:', window.pdpState);
  }
}

// ============================================
// INITIALIZE STYLE OPTIONS (Tier 1 & Tier 2)
// ============================================
function initializeStyleOptions() {
  console.log('=== Style Options Initialization ===');
  
  const styleMetafields = window.productStyleMetafields?.[window.productHandle] || {};
  console.log('Style Metafields:', styleMetafields);
  
  // Build type-to-names mapping and extract unique types
  const typeToNames = {};
  const nameCapitalizationMap = {};
  const uniqueTypes = new Set();
  
  // Keep in step with the Shopify "style" metaobject definition
  // (MetaobjectDefinition/17211228526) and the sheet's OptionList tab.
  // Keys are the metaobject name lower-cased; missing keys fall back to
  // first-letter capitalisation, which mis-renders multi-word names
  // (e.g. "pad print (single color)" -> "Pad print (single color)").
  const capitalizeMap = {
    'dtf': 'DTF',
    'dtg': 'DTG',
    'embossing': 'Embossing',
    'embroidery': 'Embroidery',
    'heat transfer printing': 'Heat Transfer Printing',
    'laser engraving': 'Laser Engraving',
    'mechanical engraving': 'Mechanical Engraving',
    'none': 'None',
    'pad print (single color)': 'Pad Print (Single Color)',
    'uv printing': 'UV Printing'
  };
  
  for (const [name, type] of Object.entries(styleMetafields)) {
    if (!typeToNames[type]) {
      typeToNames[type] = [];
    }
    typeToNames[type].push(name);
    nameCapitalizationMap[name] = capitalizeMap[name] || name.charAt(0).toUpperCase() + name.slice(1);
    uniqueTypes.add(type);
  }
  
  // Render segmented control options from unique types (TIER 1)
  const segmentedTrack = document.querySelector('[id^="segmented-control-track-"]');
  let firstType = null;
  
  if (segmentedTrack) {
    const existingOptions = segmentedTrack.querySelectorAll('.segmented-control-option');
    existingOptions.forEach(opt => opt.remove());
    
    uniqueTypes.forEach((type, index) => {
      if (index === 0) firstType = type;
      
      const typeButton = document.createElement('button');
      typeButton.type = 'button';
      typeButton.className = 'segmented-control-option';
      typeButton.textContent = type;
      typeButton.setAttribute('data-style-type', type);
      
      segmentedTrack.appendChild(typeButton);
    });
  }
  
  // Store for later use
  window.pdpStyleMetadata = {
    typeToNames,
    nameCapitalizationMap,
    uniqueTypes: Array.from(uniqueTypes)
  };
  
  // Function to update segmented control indicator position
  function updateIndicatorPosition(selectedIndex) {
    const indicator = document.querySelector('.segmented-control-indicator');
    if (indicator) {
      const offset = selectedIndex * 50;
      indicator.style.left = `calc(4px + ${offset}%)`;
    }
  }
  
  // Function to render name buttons for a given type (TIER 2)
  function renderNameButtons(styleType) {
    const nameButtonsContainer = document.querySelector('[id^="style-name-group-"]');
    if (nameButtonsContainer) {
      nameButtonsContainer.innerHTML = '';
      
      let namesForType = typeToNames[styleType] || [];
      
      // If "None" type has no names, add a default "None" option
      if (styleType === 'None' && namesForType.length === 0) {
        namesForType = ['None'];
      }
      
      namesForType.forEach((name, index) => {
        /*
         * The metafield name is lowercased; the product's option value is not.
         * Resolve against the product so the button label, data-style-name and
         * pdpState.option1 all carry the string the variants actually use.
         */
        const realValue = resolveStyleOptionValue(nameCapitalizationMap[name] || name);
        
        const nameButton = document.createElement('button');
        nameButton.type = 'button';
        nameButton.className = 'style-name-button';
        nameButton.textContent = realValue;
        nameButton.setAttribute('data-style-name', realValue);
        nameButton.setAttribute('data-style-type', styleType);
        
        if (index === 0) {
          nameButton.classList.add('selected');
          // Update state
          window.pdpState.option1 = realValue;
        }
        
        nameButton.addEventListener('click', function(e) {
          e.preventDefault();
          console.log('Tier 2 button clicked:', realValue);
          
          // Update state
          window.pdpState.option1 = realValue;
          
          // Update UI
          document.querySelectorAll('.style-name-button').forEach(btn => {
            btn.classList.remove('selected');
          });
          nameButton.classList.add('selected');
          
          // Resolve variant
          resolveVariant();
        });
        
        nameButtonsContainer.appendChild(nameButton);
      });
    }
  }
  
  // Setup Tier 1 (Type) button click handlers
  const segmentedOptions = document.querySelectorAll('.segmented-control-option');
  
  segmentedOptions.forEach((button, index) => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const styleType = button.getAttribute('data-style-type');
      console.log('Tier 1 button clicked:', styleType);
      
      // Update state
      window.pdpState.currentType = styleType;
      
      // Update UI
      document.querySelectorAll('.segmented-control-option').forEach(btn => {
        btn.classList.remove('selected');
      });
      button.classList.add('selected');
      updateIndicatorPosition(index);
      
      // Handle "None" type specially
      if (styleType === 'None') {
        window.pdpState.option1 = 'None';
        const nameButtonsContainer = document.querySelector('[id^="style-name-group-"]');
        if (nameButtonsContainer) {
          nameButtonsContainer.innerHTML = '';
        }
      } else {
        // Render Tier 2 buttons
        renderNameButtons(styleType);
      }
      
      // Resolve variant
      resolveVariant();
    });
  });
  
  // Auto-select default type on page load
  const defaultSelectedType = 'Customization';
  const typeToSelect = defaultSelectedType || firstType;
  
  if (typeToSelect) {
    window.pdpState.currentType = typeToSelect;
    
    const defaultTypeButton = document.querySelector(`.segmented-control-option[data-style-type="${typeToSelect}"]`);
    if (defaultTypeButton) {
      defaultTypeButton.classList.add('selected');
      
      const selectedIndex = Array.from(segmentedOptions).indexOf(defaultTypeButton);
      updateIndicatorPosition(selectedIndex);
      
      renderNameButtons(typeToSelect);
    }
  }
  
  console.log('=== Style Options Setup Complete ===');
}

// Initialize color swatches
function initializeColorSwatches() {
  /*
   * Two swatch kinds, both select the same colour option:
   *   .color-swatch       solid colour  -> hex in `data-color`
   *   .color-image-button patterned     -> design image, `data-colour` is the
   *                                        option VALUE (there is no meaningful
   *                                        hex for a design)
   * Either way the VALUE we must store in pdpState is the option value, which is
   * what `data-color` holds on solid swatches too (not the hex).
   */
  const colorSwatches = document.querySelectorAll('.color-swatch, .color-image-button');
  
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      
      const selectedColor = this.getAttribute('data-color') || this.getAttribute('data-colour');
      console.log('Color selected:', selectedColor);
      
      // Determine which option index Color is (could be option2 or option3 depending on product)
      const colorOptionIndex = window.productData && window.productData.options 
        ? window.productData.options.findIndex(opt => opt.toLowerCase() === 'color')
        : 2; // Default to option3 (index 2)
      
      console.log('Color option index:', colorOptionIndex);

      /*
       * Refresh every OTHER option position from the radios before resolving.
       * The colour picker only owns the colour slot; the rest of pdpState can
       * be stale (a size change used to leave option3 pointing at the previous
       * size), and a stale position makes resolveVariant() miss the variant.
       */
      syncPdpStateFromRadios(colorOptionIndex);
      
      // Update state based on actual option position
      if (colorOptionIndex === 1) {
        window.pdpState.option2 = selectedColor;
      } else if (colorOptionIndex === 2) {
        window.pdpState.option3 = selectedColor;
      }
      
      // Update UI
      colorSwatches.forEach(s => s.classList.remove('selected'));
      this.classList.add('selected');

      // Update color legend text
      const colorLegend = document.getElementById('color-option-title');
      if (colorLegend) {
        colorLegend.textContent = 'Color: ' + selectedColor;
      }
      
      // Resolve variant
      resolveVariant();
    });
  });
}

// Initialize bulk price calculator
function initializeBulkPriceCalculator() {
  const bulkTiers = [
    { items: 1, discount: 0 },
    { items: 3, discount: 15 },
    { items: 5, discount: 20 },
    { items: 10, discount: 30 },
    { items: 100, discount: 35 },
  ];
  
  // Get base price from product data or price element
  let basePrice = 348; // Default fallback
  
  if (window.productData && window.productData.price) {
    basePrice = window.productData.price / 100; // Convert cents to dollars
  } else {
    const priceElement = document.querySelector('.product-price');
    if (priceElement && priceElement.dataset.basePrice) {
      basePrice = parseInt(priceElement.dataset.basePrice) / 100;
    }
  }
  const bulkSlider = document.getElementById('bulk-quantity-slider');
  const bulkQtyBadge = document.getElementById('bulk-qty-badge');
  const bulkDiscountedPrice = document.getElementById('bulk-discounted-price');
  const bulkDiscountPercent = document.getElementById('bulk-discount-percent');
  
  // Update slider max value to match number of tiers
  if (bulkSlider) {
    bulkSlider.max = bulkTiers.length - 1;
    
    bulkSlider.addEventListener('input', function() {
      const tierIndex = parseInt(this.value);
      const currentTier = bulkTiers[tierIndex];
      
      const discountedPrice = Math.round(basePrice * (1 - currentTier.discount / 100));
      
      const itemText = currentTier.items === 1 ? 'item' : 'items';
      bulkQtyBadge.textContent = `${currentTier.items} ${itemText}`;
      
      bulkDiscountedPrice.textContent = `HK$ ${discountedPrice}`;
      
      bulkDiscountPercent.textContent = `${currentTier.discount}% Off`;
      
      // Update the main product price display with discount applied
      const priceElement = document.querySelector('.product-price');
      if (priceElement) {
        // discountedPrice is already in dollars (basePrice is in dollars)
        priceElement.textContent = `$${discountedPrice.toFixed(2)}`;
        console.log('Product price updated to:', `$${discountedPrice.toFixed(2)}`);
      }
    });
  }
}

// ============================================
// DYNAMIC ACTION CONTROLLER
// ============================================

// Main button click handler - hijacks the click to either open designer or submit cart
// Mirror the current style into the two PDP actions: Add to Cart is always
// available; Customize only makes sense when the style is not "None".
(function syncPdpActionButtons() {
  function sync() {
    var button = document.getElementById('main-pdp-button');
    if (!button) return;
    var style = window.pdpState && window.pdpState.option1;
    var designer = window.isDesignerUser === true;
    var giftLabel = '';
    try {
      var editRaw = sessionStorage.getItem('xg_gift_edit');
      var addRaw = sessionStorage.getItem('xg_gift_add');
      var giftId = editRaw ? ((JSON.parse(editRaw) || {}).giftId || '') : (addRaw || '');
      var gift = giftId && window.xgMyGifts && window.xgMyGifts.get(giftId);
      if (gift) giftLabel = style === 'None' ? 'Add to Gift Box' : 'Customize';
    } catch (error) { giftLabel = ''; }
    // Clicking Add to Cart on a gift-capable product opens the Cart / Gift Box
    // choice directly - there is no intermediate confirm screen.
    button.textContent = giftLabel || ((!designer || !style || style === 'None') ? 'Add to Cart' : 'Customize');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  window.addEventListener('load', sync);
  setTimeout(sync, 800);
  setTimeout(sync, 2000);
  window.xgSyncPdpButtons = sync;
  document.addEventListener('change', sync, true);
  document.addEventListener('click', function () { setTimeout(sync, 80); }, true);
})();

async function handleProductAction(button) {
  const container = button.closest('.product-action-container');
  const isDesigner = container && container.getAttribute('data-is-designer') === 'true';
  const variantId = container && container.getAttribute('data-variant-id');

  const style = window.pdpState && window.pdpState.option1;

  if (isDesigner && style && style !== 'None') {
    openDeliverPrintDesigner();
    return;
  }


function xgGiftNextSlot(gift) {
  const count = Math.max(1, Number(gift && gift.count ? gift.count : 1));
  const used = new Set();
  ((gift && gift.items) || []).forEach(function (item) {
    const slot = Number(item && item.slotIndex);
    if (Number.isFinite(slot) && slot >= 0 && slot < count) used.add(slot);
  });
  for (let i = 0; i < count; i += 1) { if (!used.has(i)) return i; }
  return -1;
}

  let earlyGiftId = '';
  let earlyGiftIndex = 0;
  try {
    const editRaw = sessionStorage.getItem('xg_gift_edit');
    const addRaw = sessionStorage.getItem('xg_gift_add');
    if (editRaw) {
      const parsed = JSON.parse(editRaw) || {};
      earlyGiftId = parsed.giftId || '';
      earlyGiftIndex = Number(parsed.index || 0);
    } else if (addRaw) {
      earlyGiftId = addRaw;
    }
  } catch (error) { earlyGiftId = ''; }
  if (earlyGiftId && window.xgMyGifts) {
    const earlyGift = window.xgMyGifts.get(earlyGiftId);
    if (!earlyGift) { window.location.href = '/pages/my-gifts'; return; }
    const idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    const pickedVariant = variantId || (idInput && idInput.value);
    if (!pickedVariant) { window.xgNotify('Choose an option first.'); return; }
    fetch('/variants/' + encodeURIComponent(pickedVariant) + '.js').then(function (response) { return response.json(); }).then(function (variant) {
      const item = {
        type: 'product',
        title: variant.product_title || String(variant.name || '').split(' - ')[0],
        handle: (window.productData && window.productData.handle) || '',
        variantId: variant.id,
        variantTitle: variant.title,
        price: Math.round(Number(variant.price || 0)),
        image: variant.featured_image && variant.featured_image.src ? variant.featured_image.src : ''
      };
      const editedIndex = (function () {
        try { return sessionStorage.getItem('xg_gift_edit') ? earlyGiftIndex : -1; } catch (error) { return -1; }
      })();
      const plainItem = Object.assign({}, item);
      if (editedIndex > -1 && earlyGift.items[editedIndex]) {
        // Explicit edit of an existing slot item.
        earlyGift.items[editedIndex] = Object.assign(earlyGift.items[editedIndex], plainItem);
      } else {
        // A plain product is a NEW item: never overwrite a configured one.
        const freeSlot = xgGiftNextSlot(earlyGift);
        if (freeSlot < 0) { window.xgNotify('This gift box is full.'); return; }
        plainItem.slotIndex = freeSlot;
        earlyGift.items.push(plainItem);
      }
      earlyGift.status = 'draft';
      delete earlyGift.group;
      window.xgMyGifts.save(earlyGift);
      try { sessionStorage.removeItem('xg_gift_edit'); } catch (error) {}
      window.location.href = '/pages/my-gifts?gift=' + encodeURIComponent(earlyGiftId) + '&step=2';
    }).catch(function () { window.xgNotify('Could not add this item to the gift set.'); });
    return;
  }

  if (isDesigner && style && style !== 'None') {
    openDeliverPrintDesigner();
    return;

  // Plain product on a gift-capable PDP: open the cart / gift-box dialog instead of
  // submitting the form directly.
  if ((!style || style === 'None') && typeof window.xgOpenGiftDestination === 'function'
      && window.__xgGiftSets && window.__xgGiftSets.length) {
    window.xgOpenGiftDestination();
    return;
  }
  }

  let giftContextId = '';
  let giftContextIndex = 0;
  try {
    const editRaw = sessionStorage.getItem('xg_gift_edit');
    const addRaw = sessionStorage.getItem('xg_gift_add');
    if (editRaw) {
      const parsed = JSON.parse(editRaw) || {};
      giftContextId = parsed.giftId || '';
      giftContextIndex = Number(parsed.index || 0);
    } else if (addRaw) {
      giftContextId = addRaw;
    }
  } catch (error) { giftContextId = ''; }
  if (giftContextId && window.xgMyGifts) {
    const gift = window.xgMyGifts.get(giftContextId);
    if (!gift) { window.location.href = '/pages/my-gifts'; return; }
    if ((gift.items || []).length >= gift.count && !gift.items[giftContextIndex]) {
      window.xgNotify('This gift box is full.');
      return;
    }
    const idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    const targetVariant = variantId || (idInput && idInput.value);
    if (!targetVariant) { window.xgNotify('Choose an option first.'); return; }
    fetch('/variants/' + encodeURIComponent(targetVariant) + '.js').then(function (response) { return response.json(); }).then(function (variant) {
      const item = {
        type: 'product',
        title: variant.product_title || String(variant.name || '').split(' - ')[0],
        handle: (window.productData && window.productData.handle) || '',
        variantId: variant.id,
        variantTitle: variant.title,
        price: Math.round(Number(variant.price || 0)),
        image: variant.featured_image && variant.featured_image.src ? variant.featured_image.src : ''
      };
      const editedIndex2 = (function () {
        try { return sessionStorage.getItem('xg_gift_edit') ? giftContextIndex : -1; } catch (error) { return -1; }
      })();
      const plainItem2 = Object.assign({}, item);
      if (editedIndex2 > -1 && gift.items[editedIndex2]) {
        gift.items[editedIndex2] = Object.assign(gift.items[editedIndex2], plainItem2);
      } else {
        const freeSlot2 = xgGiftNextSlot(gift);
        if (freeSlot2 < 0) { window.xgNotify('This gift box is full.'); return; }
        plainItem2.slotIndex = freeSlot2;
        gift.items.push(plainItem2);
      }
      gift.status = 'draft';
      delete gift.group;
      window.xgMyGifts.save(gift);
      try { sessionStorage.removeItem('xg_gift_edit'); } catch (error) {}
      window.location.href = '/pages/my-gifts?gift=' + encodeURIComponent(giftContextId) + '&step=2';
    }).catch(function () { window.xgNotify('Could not add this item to the gift set.'); });
    return;
  }

  const form = document.querySelector('form[action="/cart/add"]');
  const giftSets = window.__xgGiftSets || [];

  // Gift-set products: ask first, then add the selected bundle.
  if (giftSets.length && typeof window.xgGiftSetPick === 'function') {
    const picked = await window.xgGiftSetPick();
    if (picked === false) return;
    if (picked) {
      const set = giftSets.find((item) => item.id === picked);
      if (!set) return;
      const group = window.__xgPickedGiftGroup || ('xg-gift-' + Date.now());
      window.__xgPickedGiftGroup = null;
      const percent = (set.action && set.action.value) || set.value || 0;
      const props = {
        _gift_group: group,
        _gift_box: set.id,
        _gift_title: set.title + ' gift box',
        _gift_percent: String(percent),
        _gift_parent_variant: set.masterGiftVariantId || '',
        _gift_combo: '1',
        _bundle_id: set.id
      };
      const items = [];
      if (set.masterGiftVariantId) {
        items.push({ id: Number(String(set.masterGiftVariantId).split('/').pop()), quantity: 1, properties: Object.assign({}, props, { _gift_parent: '1' }) });
      }
      items.push({ id: Number(variantId), quantity: 1, properties: props });
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(await response.text());
        const added = await response.json();
        if (window.xgWriteGiftConfig) await window.xgWriteGiftConfig(group, set, added, items[items.length - 1]);
        var boxId = String(set.id).replace(/^gift-box-/, '');
        window.location.href = '/pages/christmas-gift?box=' + encodeURIComponent(boxId) + '&gift_group=' + encodeURIComponent(group);
      } catch (error) {
        console.error('[pdp gift set add]', error);
        alert('Could not add to cart.');
      }
      return;
    }
  }

  if (form) {
    // Skip the cart page: add the line, then go straight to checkout.
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var addId = idInput && Number(idInput.value);
    var addQty = qtyInput && Number(qtyInput.value) > 0 ? Number(qtyInput.value) : 1;
    if (!addId) { form.submit(); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: addId, quantity: addQty }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart add failed');
      window.location.href = '/checkout';
    }).catch(function () { form.submit(); });
  } else {
    console.warn('Cart form not found');
  }
}

// ============================================
// DESIGNER OVERLAY - back button handling
// ============================================
// The designer opens as a fullscreen overlay on top of the SAME page, so without
// this the mobile back gesture / Android back button leaves the product page
// entirely (it pops the previous history entry) instead of dismissing the overlay.
//
// Fix: opening the overlay pushes one history entry, and a popstate listener
// consumes that entry to close the overlay. So the first back closes the designer
// and the customer stays on the product detail page; a second back navigates away
// as normal. Works for every product because it is bound to the overlay itself,
// not to a template.
window.designerOverlayState = {
  open: false,
  closeInProgress: false,
  // Conditional flags that decide whether the back press is blocked.
  warnOnClose: true,        // ask before dismissing the designer
  designStarted: false,     // set once the customer interacts with the designer
  warningDismissed: false   // remember "discard anyway" for this session
};

/**
 * Block-and-warn guard for the system back button / back gesture.
 *
 * HOW THE BACK PRESS IS ACTUALLY INTERCEPTED
 * A browser cannot cancel a back navigation. What we can do is make the page own
 * the history entry: opening the designer pushes one entry, so the back press
 * pops THAT entry and no navigation happens - the page never unloads. We then
 * decide what to do:
 *   - confirm() not accepted -> push the entry back, so the customer visibly does
 *     not go anywhere (this is the "block" the customer experiences)
 *   - accepted (or no warning wanted) -> close the designer and let the back be
 *     consumed, leaving the customer on the product detail page
 *
 * LIMITATION: whether a design actually exists lives inside the cross-origin
 * designer iframe (merchamber.netlify.app), which this page cannot read. So
 * `designStarted` is only a heuristic - set on the first touch/click inside the
 * overlay. To require a real signal, have the designer app postMessage its dirty
 * state and set designStarted from that instead. The prompt is therefore kept
 * opt-in and can be disabled with designerOverlayState.warnOnClose = false.
 */
function shouldWarnBeforeClosingDesigner() {
  return window.designerOverlayState.warnOnClose === true &&
         window.designerOverlayState.warningDismissed !== true;
}

function confirmDiscardDesign() {
  try {
    return window.confirm('Leave the designer? Your design will not be saved.');
  } catch (error) {
    // Some embedded webviews block dialogs; never let that strand the overlay.
    return true;
  }
}

/*
 * NOTE: the beforeunload page-leave guard has been REMOVED.
 *
 * It made the browser show its own "Leave site?" dialog whenever a customer left
 * the page with the designer open, which reads as a back warning and interrupts the
 * normal flow. Nothing replaces it: pressing back now closes the designer and stays
 * on the product page (see the popstate handler), which is the behaviour requested.
 *
 * If a leave guard is ever wanted again, it needs a `beforeunload` listener that
 * sets event.returnValue - and it should be scoped to genuine unsaved work, which
 * only the designer app can report (it is cross-origin, so this page cannot tell).
 */

function closeDesignerOverlay() {
  const overlay = document.getElementById('designer-iframe-overlay');
  if (overlay) overlay.remove();
  // The iframe keeps running (audio/video) unless removed from the DOM, which
  // remove() above handles.
  window.designerOverlayState.open = false;
  window.designerOverlayState.designStarted = false;
  document.body.style.overflow = '';
}

/**
 * Close the overlay the same way the back gesture would, so the history stack
 * stays balanced. Called by the "Back to Shop" button.
 */
function requestCloseDesignerOverlay() {
  if (!window.designerOverlayState.open) {
    closeDesignerOverlay();
    return;
  }
  if (window.designerOverlayState.closeInProgress) return;
  window.designerOverlayState.closeInProgress = true;
  // Reuses the history entry that opening the overlay pushed. popstate then runs
  // closeDesignerOverlay(), so there is exactly one code path that closes.
  window.history.back();
  // Safety net: if the environment does not emit popstate, close anyway.
  setTimeout(function () {
    if (window.designerOverlayState.closeInProgress && window.designerOverlayState.open) {
      closeDesignerOverlay();
      window.designerOverlayState.closeInProgress = false;
    }
  }, 250);
}

/**
 * The back press lands here.
 *
 * At this point the pushed entry has already been popped, so this is the moment
 * to decide: warn, or close. Cancel re-pushes the entry, which restores the URL
 * and keeps the designer open - the customer sees the back press "do nothing",
 * which is the block. It also means the entry is deliberately still on the stack,
 * so the next back press asks again.
 */
window.addEventListener('popstate', function () {
  if (!window.designerOverlayState.open) return;

  if (shouldWarnBeforeClosingDesigner()) {
    if (!confirmDiscardDesign()) {
      // Blocked: put the history entry back so nothing was navigated.
      window.history.pushState({ designerOverlay: true }, '', window.location.href);
      console.log('[Designer] back blocked by the leave warning');
      return;
    }
    // Accepted the warning, so do not ask again this session.
    window.designerOverlayState.warningDismissed = true;
  }

  closeDesignerOverlay();
  window.designerOverlayState.closeInProgress = false;
  console.log('[Designer] back gesture closed the overlay - staying on the product page');
});

// Open DeliverPrint designer in fullscreen iframe
function openDeliverPrintDesigner() {
  console.log('Opening DeliverPrint designer');
  
  // Get current variant from state
  const variantId = window.pdpState.variantId;
  
  console.log('Designer state:', { variantId });
  
  // Go straight to quick cust with the selected product + variant.
  const quickUrl = '/pages/quickcust?product=' + encodeURIComponent(window.productData.id) + '&vid=' + encodeURIComponent(variantId);
  window.location.href = quickUrl;
  return;
  console.log('Designer URL:', url);
  
  // Get product info
  const productName = window.productData.title || 'Product';
  const variant = window.productData.variants.find(v => v.id === parseInt(variantId));
  const price = variant ? (variant.price / 100).toFixed(2) : '0.00';
  const currency = window.productData.currency || 'HKD';
  
  // Create fullscreen iframe overlay
  const overlay = document.createElement('div');
  overlay.id = 'designer-iframe-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 999999;
    display: flex;
    flex-direction: column;
  `;
  
  overlay.innerHTML = `
    <div id="iframe-header" class="iframe-header" style="padding: 12px 20px; background: #fff; border-bottom: 1px solid #e5e5e5; display: flex; justify-content: space-between; align-items: center;">
      <div id="iframe-header-info" class="iframe-header-info">
        <h3 id="iframe-header-name" class="iframe-header-name" style="margin: 0; font-size: 12px; font-weight: 600; color: #232323; line-height: 1.3;">${productName}</h3>
        <p id="iframe-header-price" class="iframe-header-price" style="margin: 2px 0 0 0; font-size: 12px; font-weight: 600; color: #232323;">${currency} ${price}</p>
      </div>
      <button id="iframe-close-btn" class="iframe-close-btn" type="button" style="padding: 8px 14px; background: #333; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: 500; white-space: nowrap;">Back to Shop</button>
    </div>
    <iframe id="designer-iframe" class="designer-iframe" src="${url}" style="flex-grow: 1; border: none; width: 100%; height: 100%;"></iframe>
  `;
  
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  // Make the back gesture close this overlay instead of leaving the product page.
  if (!window.designerOverlayState.open) {
    window.designerOverlayState.open = true;
    window.designerOverlayState.closeInProgress = false;
    window.designerOverlayState.designStarted = false;
    window.history.pushState({ designerOverlay: true }, '', window.location.href); // preserves any ?variant= param
    // (No page-leave guard is registered - see the note above closeDesignerOverlay.)
  }

  // Bound here rather than with an inline onclick so the history entry is cleaned
  // up correctly when the customer uses the button instead of the back gesture.
  const closeButton = overlay.querySelector('#iframe-close-btn');
  if (closeButton) closeButton.addEventListener('click', requestCloseDesignerOverlay);

  /*
   * Note whether the customer has interacted with the designer at all.
   *
   * These listeners sit on the OVERLAY, not on the iframe document: the designer
   * is cross-origin, so its internal events cannot be observed from this page.
   * Touches and clicks over the iframe do not bubble to the parent either, which
   * means this only fires for the overlay's own chrome (the header and the Back to
   * Shop button). It is a weak signal - treat `designStarted` as a hook, and set
   * it from a postMessage handshake if the designer app can report real state.
   */
  overlay.addEventListener('touchstart', function () {
    window.designerOverlayState.designStarted = true;
  }, { passive: true });
  overlay.addEventListener('click', function () {
    window.designerOverlayState.designStarted = true;
  }, { passive: true });

  console.log('Designer iframe opened');
}

// Handle Style Button Action (legacy - kept for compatibility)
function handleStyleAction() {
  const button = document.getElementById('main-pdp-button');
  if (button) {
    handleProductAction(button);
  }
}

/*
 * Format cents using the STORE's money format.
 *
 * updateVariantPricing() used to write a hardcoded `HK$ ${cents/100}`, which
 * disagreed with everything else on the page: the bulk pricing calculator, the
 * tier table and the server-rendered price all use the shop's "${{amount}}"
 * format, so the unit price flipped to "HK$ 18.00" the moment a variant was
 * picked. The format comes off the calculator root, which Liquid fills from
 * shop.money_format; the plain-dollar fallback only applies if that is absent.
 */
function formatStoreMoney(cents) {
  const root = document.querySelector('[data-bulk-pricing]');
  const format = root && root.dataset.moneyFormat;
  const value = (Number(cents) / 100).toFixed(2);
  const parts = value.split('.');
  const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];

  if (format) {
    const token = format.match(/\{\{\s*\w+\s*\}\}/);
    if (token) return format.replace(token[0], amount);
  }

  return '$' + amount;
}

function updateVariantPricing(variant) {
  // Test 1: Check price element
  const priceElement = document.querySelector('.product-price');
  console.log('Price element found:', !!priceElement);
  console.log('Current price:', priceElement?.textContent);
  
  if (priceElement && variant.price) {
    /*
     * The bulk pricing calculator owns .product-price and re-prices the tier
     * ladder on variant change (see applyBasePrice in
     * snippets/bulk-pricing-calculator.liquid). Writing the base price here as
     * well is harmless while both agree on the format, and is what keeps the
     * price updating on products that render no tiers at all, where the
     * calculator bails out early.
     */
    priceElement.textContent = formatStoreMoney(variant.price);
  }
  
  // Test 2: Check if variant is set
  console.log('Active variant:', variant);
  console.log('Variant price:', variant?.price);
  
  // Update price in the designer iframe overlay header
  if (variant.price) {
    const formattedPrice = (variant.price / 100).toFixed(2);
    const currency = window.productData.currency || 'HKD';
    
    const iframeHeaderPrice = document.getElementById('iframe-header-price');
    console.log('Iframe header price element found:', !!iframeHeaderPrice);
    
    if (iframeHeaderPrice) {
      iframeHeaderPrice.textContent = `${currency} ${formattedPrice}`;
      console.log('[Parent] ✅ Updated iframe header price:', `${currency} ${formattedPrice}`);
      console.log('Price updated to:', iframeHeaderPrice?.textContent);
    }
  }
}

// Test function to verify price update is working
function testPriceUpdate() {
  const testPrice = '123.45';
  const testCurrency = 'HKD';
  
  // Test 1: Check if price element exists
  const priceEl = document.getElementById('iframe-header-price');
  console.log('[Test] Price element found:', !!priceEl);
  
  if (priceEl) {
    // Test 2: Update price directly
    const newPrice = `${testCurrency} ${testPrice}`;
    priceEl.textContent = newPrice;
    console.log('[Test] ✅ Price updated directly in parent page');
    console.log('[Test] New price:', priceEl.textContent);
  } else {
    console.error('[Test] ❌ Price element not found');
  }
}

// Test function to simulate variant change event
function testVariantChangeEvent() {
  console.log('[Test] Simulating variant change event...');
  
  // Create a mock variant object
  const mockVariant = {
    id: '53581370065262',
    price: '9700', // in cents
    available: true,
    title: 'Test Variant'
  };
  
  console.log('[Test] Mock variant:', mockVariant);
  console.log('[Test] Calling updateVariantPricing with mock variant...');
  
  // Call the updateVariantPricing function with mock variant
  updateVariantPricing(mockVariant);
  
  console.log('[Test] ✅ Variant change event simulated');
}

// Show how events are triggered in the code
function showEventTriggers() {
  console.log('=== EVENT TRIGGERS ===');
  console.log('1. resolveVariant() - Called when user changes style/size/color options');
  console.log('   → Finds matching variant from window.productVariants');
  console.log('   → Calls updateVariantPricing(matchedVariant)');
  console.log('');
  console.log('2. Color swatch click - initializeColorSwatches()');
  console.log('   → User clicks color swatch');
  console.log('   → Updates window.pdpState.option3');
  console.log('   → Calls resolveVariant()');
  console.log('   → Calls updateVariantPricing()');
  console.log('');
  console.log('3. Style button click - Tier 1 & Tier 2 buttons');
  console.log('   → User clicks style type or style name button');
  console.log('   → Updates window.pdpState.option1');
  console.log('   → Calls resolveVariant()');
  console.log('   → Calls updateVariantPricing()');
  console.log('');
  console.log('4. Manual test - testVariantChangeEvent()');
  console.log('   → Directly calls updateVariantPricing() with mock variant');
}

function updateActionButton(variant) {
  const actionButton = document.querySelector('#main-pdp-button');
  
  if (actionButton) {
    console.log('Updating button. Variant available:', variant.available, 'isDesignerUser:', window.isDesignerUser);
    
    // Untracked inventory (inventory_management null) must remain orderable in
    // this catalogue even if Shopify reports available:false for the variant.
    const untracked = variant.inventory_management === null || variant.inventory_management === undefined;
    if (!variant.available && !untracked) {
      actionButton.disabled = true;
      actionButton.textContent = 'Out of Stock';
    } else {
      actionButton.disabled = false;
      // Check if isDesignerUser is true (handle both boolean and string "true")
      const isDesigner = window.isDesignerUser === true || window.isDesignerUser === 'true';
      const isNoneStyle = window.pdpState.option1 === 'None';
      let giftLabel = '';
      try {
        const editRaw = sessionStorage.getItem('xg_gift_edit');
        const addRaw = sessionStorage.getItem('xg_gift_add');
        let giftId = '';
        if (editRaw) { giftId = (JSON.parse(editRaw) || {}).giftId || ''; }
        else if (addRaw) { giftId = addRaw; }
        const gift = giftId && window.xgMyGifts && window.xgMyGifts.get(giftId);
        if (gift) giftLabel = style === 'None' ? ('Add to ' + (gift.title || 'Gift Box')) : 'Customization';
      } catch (error) { giftLabel = ''; }
      actionButton.textContent = giftLabel || ((isDesigner && !isNoneStyle) ? 'Start Design' : 'Add to Cart');
      console.log('Button text set to:', actionButton.textContent, '(isDesigner:', isDesigner, ', isNoneStyle:', isNoneStyle, ')');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOMContentLoaded event fired');
  
  try {
    // Function to update delivery date
    function updateDeliveryDate(daysToAdd = 14) {
      const deliveryDateElement = document.getElementById('estimated-delivery-date');
      if (deliveryDateElement) {
        const today = new Date();
        const deliveryDate = new Date(today.getTime() + (daysToAdd * 24 * 60 * 60 * 1000));
        
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        const formattedDate = deliveryDate.toLocaleDateString('en-US', options).toUpperCase();
        deliveryDateElement.textContent = formattedDate;
        
        console.log('Estimated delivery date set to:', formattedDate, '(' + daysToAdd + ' days)');
      }
    }
    
    // Set initial delivery date (14 days)
    updateDeliveryDate(14);
    
    // Handle Express Order checkbox
    const expressOrderCheckbox = document.getElementById('express-order');
    if (expressOrderCheckbox) {
      expressOrderCheckbox.addEventListener('change', function() {
        const daysToAdd = this.checked ? 7 : 14;
        updateDeliveryDate(daysToAdd);
        console.log('Express order toggled:', this.checked ? 'ON (7 days)' : 'OFF (14 days)');
      });
    }
    
    initializeStyleOptions();
    initializeColorSwatches();
    initializeBulkPriceCalculator();

    /*
     * Keep pdpState in step with the radios.
     *
     * Nothing used to update option3 when the size changed, so the state could
     * describe a different variant from the one on screen - which is how
     * "select 12oz, then a 12oz-only colour" ended up resolving against 16oz.
     * A change event fires after the radio has updated, so mirroring here is
     * always reading the customer's real choice.
     */
    var pdpVariantPicker = document.querySelector('variant-radios');
    if (pdpVariantPicker) {
      pdpVariantPicker.addEventListener('change', function () {
        syncPdpStateFromRadios(-1);
      });
    }
    
    const variantInput = document.querySelector('[id^=\"product-select-\"]');
    if (variantInput && variantInput.value && window.productVariants) {
      const currentVariant = window.productVariants[variantInput.value];
      if (currentVariant && currentVariant.options) {
        window.pdpState.option1 = currentVariant.options[0];
        window.pdpState.option2 = currentVariant.options[1];
        window.pdpState.option3 = currentVariant.options[2];
        window.pdpState.variantId = currentVariant.id;

        // Find the actual color option index
        const colorOptionIndex = window.productData && window.productData.options
          ? window.productData.options.findIndex(opt => opt.toLowerCase() === 'color')
          : 2;
        const selectedColor = colorOptionIndex >= 0 ? currentVariant.options[colorOptionIndex] : null;

        const colorSwatches = document.querySelectorAll('.color-swatch, .color-image-button');
        colorSwatches.forEach(swatch => {
          const swatchValue = swatch.getAttribute('data-color') || swatch.getAttribute('data-colour');
          if (selectedColor && swatchValue === selectedColor) {
            swatch.classList.add('selected');
          } else {
            swatch.classList.remove('selected');
          }
        });

        // Set initial color legend
        const colorLegend = document.getElementById('color-option-title');
        if (colorLegend && selectedColor) {
          colorLegend.textContent = 'Color: ' + selectedColor;
        }

        updateActionButton(currentVariant);
      }
    }
    
    console.log('All initializations complete. Initial state:', window.pdpState);
  } catch (error) {
    console.error('Error during initialization:', error);
  }
});

// ============================================
// LISTEN FOR VARIANT CHANGES FROM REACT APP
// ============================================

// Listen for variant changes from the React HeaderBar component via postMessage
window.addEventListener('message', (event) => {
  if (event.data.type === 'UPDATE_PRICE') {
    console.log('[Themed Site] Received price update from React app:', event.data);
    
    const priceEl = document.getElementById('iframe-header-price');
    if (priceEl) {
      const newPrice = `${event.data.currency} ${event.data.price}`;
      priceEl.textContent = newPrice;
      console.log('[Themed Site] ✅ Updated iframe header price via postMessage:', newPrice);
    } else {
      console.warn('[Themed Site] Price element not found');
    }
  }
});

// Also listen for activeVariantChanged event from React app
window.addEventListener('activeVariantChanged', (event) => {
  const variant = event.detail?.variant;
  console.log('[Themed Site] Received activeVariantChanged event:', variant);
  
  if (variant && variant.price) {
    // Format price: convert cents to decimal
    const formattedPrice = (parseInt(variant.price) / 100).toFixed(2);
    const currency = window.productData?.currency || 'HKD';
    
    // Update iframe header price
    const priceEl = document.getElementById('iframe-header-price');
    if (priceEl) {
      const newPrice = `${currency} ${formattedPrice}`;
      priceEl.textContent = newPrice;
      console.log('[Themed Site] ✅ Updated price from activeVariantChanged event:', newPrice);
    }
  }
});

console.log('[Themed Site] Variant change listeners initialized');

// ============================================
// LISTEN FOR MODAL REQUESTS FROM DESIGNER IFRAME
// ============================================

// Listen for modal open requests from the designer iframe
window.addEventListener('message', (event) => {
  // Handle Print Guideline modal request
  if (event.data.type === 'OPEN_PRINT_GUIDELINE') {
    console.log('[Parent] Received OPEN_PRINT_GUIDELINE request from iframe');
    const modal = document.getElementById('print-guideline-modal');
    if (modal) {
      modal.style.display = 'block';
      console.log('[Parent] ✅ Print Guideline modal opened');
    } else {
      console.error('[Parent] ❌ Print Guideline modal not found');
    }
  }
  
  // Handle Size Guide modal request
  if (event.data.type === 'OPEN_SIZE_GUIDE') {
    console.log('[Parent] Received OPEN_SIZE_GUIDE request from iframe');
    const modal = document.getElementById('size-guide-modal');
    if (modal) {
      modal.style.display = 'block';
      console.log('[Parent] ✅ Size Guide modal opened');
    } else {
      console.error('[Parent] ❌ Size Guide modal not found');
    }
  }
});

console.log('[Parent] Modal request listeners initialized');

// ============================================
// TRIGGER MODAL FUNCTIONS (FOR TESTING)
// ============================================

// Function to trigger Print Guideline modal
function triggerPrintGuideline() {
  console.log('[Test] Triggering Print Guideline modal...');
  const modal = document.getElementById('print-guideline-modal');
  if (modal) {
    modal.style.display = 'block';
    console.log('[Test] ✅ Print Guideline modal opened');
  } else {
    console.error('[Test] ❌ Print Guideline modal not found');
  }
}

// Function to trigger Size Guide modal
function triggerSizeGuide() {
  console.log('[Test] Triggering Size Guide modal...');
  const modal = document.getElementById('size-guide-modal');
  if (modal) {
    modal.style.display = 'block';
    console.log('[Test] ✅ Size Guide modal opened');
  } else {
    console.error('[Test] ❌ Size Guide modal not found');
  }
}

// ============================================
// SIMPLE IFRAME EVENT LISTENER
// ============================================

// Listen for iframe button clicks and open modals
window.addEventListener('message', (event) => {
  if (event.data.action === 'openPrintGuideline') {
    triggerPrintGuideline();
  }
  if (event.data.action === 'openSizeGuide') {
    triggerSizeGuide();
  }
});

// ============================================
// LISTEN FOR MODAL REQUESTS FROM DESIGNER IFRAME
// ============================================

// Listen for modal open requests from the designer iframe
window.addEventListener('message', (event) => {
  // Handle Print Guideline modal request
  if (event.data.type === 'OPEN_PRINT_GUIDELINE') {
    console.log('[Parent] Received OPEN_PRINT_GUIDELINE request from iframe');
    const modal = document.getElementById('print-guideline-modal');
    if (modal) {
      modal.style.display = 'block';
      console.log('[Parent] ✅ Print Guideline modal opened');
    } else {
      console.error('[Parent] ❌ Print Guideline modal not found');
    }
  }
  
  // Handle Size Guide modal request
  if (event.data.type === 'OPEN_SIZE_GUIDE') {
    console.log('[Parent] Received OPEN_SIZE_GUIDE request from iframe');
    const modal = document.getElementById('size-guide-modal');
    if (modal) {
      modal.style.display = 'block';
      console.log('[Parent] ✅ Size Guide modal opened');
    } else {
      console.error('[Parent] ❌ Size Guide modal not found');
    }
  }
});

console.log('[Parent] Modal request listeners initialized');

// ============================================
// TRIGGER MODAL FUNCTIONS (FOR TESTING)
// ============================================

// Function to trigger Print Guideline modal
function triggerPrintGuideline() {
  console.log('[Test] Triggering Print Guideline modal...');
  const modal = document.getElementById('print-guideline-modal');
  if (modal) {
    modal.style.display = 'block';
    console.log('[Test] ✅ Print Guideline modal opened');
  } else {
    console.error('[Test] ❌ Print Guideline modal not found');
  }
}

// Function to trigger Size Guide modal
function triggerSizeGuide() {
  console.log('[Test] Triggering Size Guide modal...');
  const modal = document.getElementById('size-guide-modal');
  if (modal) {
    modal.style.display = 'block';
    console.log('[Test] ✅ Size Guide modal opened');
  } else {
    console.error('[Test] ❌ Size Guide modal not found');
  }
}

// ============================================
// SIMPLE IFRAME EVENT LISTENER
// ============================================

// Listen for iframe button clicks and open modals
window.addEventListener('message', (event) => {
  if (event.data.action === 'openPrintGuideline') {
    triggerPrintGuideline();
  }
  if (event.data.action === 'openSizeGuide') {
    triggerSizeGuide();
  }
});